import o from "./index.ce.vue2.js";
import t from "./index.ce.vue3.js";
import e from "./index.ce.vue4.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ r(o, [["styles", [t, e]], ["__scopeId", "data-v-e00c8bc1"]]);
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/index.ce.vue.js
// module id = 1278
// module chunks = 67